import * as React from "react";
import type { SVGProps } from "react";
const SvgPrimarySerum = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 21 20"
    width="1em"
    height="1em"
    role="img"
    focusable={false}
    {...props}
  >
    <path
      stroke="#1D1D1D"
      strokeWidth={0.575}
      d="M12.433 7.64h.287c.318 0 .575.257.575.575v9.946a.46.46 0 0 1-.194.39c-.349.23-1.19.65-2.681.65-1.49 0-2.332-.42-2.681-.65a.46.46 0 0 1-.194-.39V8.215c0-.318.257-.575.575-.575h.287m4.026 0V4.467a.575.575 0 0 0-.575-.575m.575 3.748s-.575.577-2.013.577-2.013-.577-2.013-.577m3.45-3.748s-.574.3-1.437.3-1.438-.3-1.438-.3m2.876 0V2.525s.862-.288.862-1.15C12.72.8 11.57.8 10.42.8c-.735 0-1.118.164-1.298.283-.1.066-.14.184-.14.303v2.506m0 0a.575.575 0 0 0-.575.575V7.64"
    />
  </svg>
);
export default SvgPrimarySerum;
